var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "newQianniu" } },
    [
      _c(
        "el-tabs",
        {
          attrs: { "tab-position": "left" },
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.tabCurrent,
            callback: function($$v) {
              _vm.tabCurrent = $$v
            },
            expression: "tabCurrent"
          }
        },
        [
          _c("el-tab-pane", { attrs: { name: "first" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [
                  _vm._v("1、搜狗输入法的截屏功能")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-first" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "first",
                      src:
                        "http://res.study.itaojin.cn/2023-02/62fe7f6473a2439eb02b097878cc8ca0.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t您的浏览器不支持 video 标签。\n\t\t\t\t\t"
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-first" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-first" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowqh1_1,
                          expression: "isShowqh1_1"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/qh1-1.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qhtb1-1",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/qhtb1-1.png")
                        },
                        on: { mousemove: _vm.showLoginqh1_1 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowqh1_2,
                          expression: "isShowqh1_2"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/qh1-2.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qhtb1-2",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/qhtb1-2.png")
                        },
                        on: { click: _vm.showLoginqh1_2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowqh1_3,
                          expression: "isShowqh1_3"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/qh1-3.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qhtb1-3",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/qhtb1-3.png")
                        },
                        on: { mousemove: _vm.showLoginqh1_3 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowqh1_4,
                          expression: "isShowqh1_4"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/qh1-4.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qhtb1-4",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/qhtb1-4.png")
                        },
                        on: { click: _vm.showLoginqh1_4 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowqh1_5,
                          expression: "isShowqh1_5"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/qh1-5.png")
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowjp1_1,
                          expression: "isShowjp1_1"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/qh1-5.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "jptb1-1",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/jptb1-1.png")
                        },
                        on: { mousemove: _vm.showLoginjp1_1 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowjp1_2,
                          expression: "isShowjp1_2"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/jp1-1.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "jptb1-2",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/jptb1-2.png")
                        },
                        on: { click: _vm.showLoginjp1_2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowjp1_3,
                          expression: "isShowjp1_3"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/jp1-2.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "jptb1-3",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/jptb1-3.png")
                        },
                        on: { mousemove: _vm.showLoginjp1_3 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowjp1_4,
                          expression: "isShowjp1_4"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/jp1-3.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "jptb1-3",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/jptb1-3.png")
                        },
                        on: {
                          contextmenu: function($event) {
                            $event.preventDefault()
                            $event.stopPropagation()
                            return _vm.showLoginjp1_4($event)
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowjp1_5,
                          expression: "isShowjp1_5"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/jp1-4.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "jptb1-4",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/jptb1-4.png")
                        },
                        on: { click: _vm.showLoginjp1_5 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowjp1_6,
                          expression: "isShowjp1_6"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/jp1-5.png")
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowkj1_1,
                          expression: "isShowkj1_1"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/kj1-1.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "kjtb1-1",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/kjtb1-1.png")
                        },
                        on: { mousemove: _vm.showLoginkj1_1 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowkj1_2,
                          expression: "isShowkj1_2"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/kj1-2.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "kjtb1-2",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/kjtb1-1.png")
                        },
                        on: { click: _vm.showLoginkj1_2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowkj1_3,
                          expression: "isShowkj1_3"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/kj1-1.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "kjtb1-3",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/kj1-3.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "kjtb1-4",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/kjtb1-2.png")
                        },
                        on: { click: _vm.showLoginkj1_3 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowkj1_4,
                          expression: "isShowkj1_4"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/kj1-4.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "kjtb1-5",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/kjtb1-3.png")
                        },
                        on: { mousemove: _vm.showLoginkj1_4 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowkj1_5,
                          expression: "isShowkj1_5"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/kj1-5.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "kjtb1-6",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/kjtb1-4.png")
                        },
                        on: { click: _vm.showLoginkj1_5 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowkj1_6,
                          expression: "isShowkj1_6"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/kj1-6.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "kjtb1-6",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/kjtb1-4.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "kjtb1-6-1_box" }, [
                        _c("img", {
                          staticClass: "kjtb1-6-1",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/sougou/kj1-7.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "kjtb1-8",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/sougou/kjtb1-6.png")
                          },
                          on: { mousemove: _vm.showLoginkj1_6 }
                        })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowkj1_8,
                          expression: "isShowkj1_8"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/kj1-8.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "kjtb1-9",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/kjtb1-7.png")
                        },
                        on: { click: _vm.showLoginkj1_7 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowkj1_9,
                          expression: "isShowkj1_9"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/kj1-9.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "kjtb1-9-1" }, [
                        _c("img", {
                          staticClass: "kjtb1-10",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/sougou/kjtb1-8-1.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "kjtb1-11",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/sougou/kjtb1-9.png")
                          },
                          on: { mousemove: _vm.showLoginkj1_9 }
                        })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowkj1_11,
                          expression: "isShowkj1_11"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/kj1-10.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "kjtb1-12",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/kjtb1-10.png")
                        },
                        on: { click: _vm.showLoginkj1_10 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowkj1_12,
                          expression: "isShowkj1_12"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/kj1-11.png")
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
                  ]),
                  _vm._v(" "),
                  _vm.isShowqh1_1 ||
                  _vm.isShowqh1_2 ||
                  _vm.isShowqh1_3 ||
                  _vm.isShowqh1_4 ||
                  _vm.isShowqh1_5
                    ? _c("p", [
                        _vm._v("将"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("左侧练习场")]
                        ),
                        _vm._v("中，"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("右下角")]
                        ),
                        _vm._v("的输入法"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("切换")]
                        ),
                        _vm._v("为"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("搜狗输入法")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowjp1_1 ||
                  _vm.isShowjp1_2 ||
                  _vm.isShowjp1_3 ||
                  _vm.isShowjp1_4 ||
                  _vm.isShowjp1_5 ||
                  _vm.isShowjp1_6
                    ? _c("p", [
                        _vm._v("打开搜狗输入法的"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("智能输入助手,")]
                        ),
                        _vm._v("将"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("截屏")]
                        ),
                        _vm._v("功能快捷方式设置到"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("桌面")]
                        ),
                        _vm._v("上")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowkj1_1 ||
                  _vm.isShowkj1_2 ||
                  _vm.isShowkj1_3 ||
                  _vm.isShowkj1_4 ||
                  _vm.isShowkj1_5 ||
                  _vm.isShowkj1_6 ||
                  _vm.isShowkj1_8 ||
                  _vm.isShowkj1_9 ||
                  _vm.isShowkj1_10 ||
                  _vm.isShowkj1_11 ||
                  _vm.isShowkj1_12
                    ? _c("p", [
                        _vm._v("在搜狗输入法的"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("菜单")]
                        ),
                        _vm._v("中，将"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("截屏")]
                        ),
                        _vm._v("的"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("快捷键")]
                        ),
                        _vm._v("设置为Ctrl+Alt+Q")
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-first" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudyFirst }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-second")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n\t\t\t\t\t\t查看学习资料\n\t\t\t\t\t")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: require("../../../static/newqianniu/ppt.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("搜狗输入法练习-截屏功能.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "second" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [
                  _vm._v("2、搜狗输入法的快捷短语")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-second" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "second",
                      src:
                        "http://res.study.itaojin.cn/2023-02/82f510f141db4151a86594302eac1b11.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t您的浏览器不支持 video 标签。\n\t\t\t\t\t"
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-second" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-second" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowdy1_1,
                          expression: "isShowdy1_1"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/dy1-1.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "dytb1-1",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/dytb1-1.png")
                        },
                        on: { mousemove: _vm.showLogindy1_1 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowdy1_2,
                          expression: "isShowdy1_2"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/dy1-2.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "dytb1-2",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/dytb1-2.png")
                        },
                        on: { click: _vm.showLogindy1_2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowdy1_3,
                          expression: "isShowdy1_3"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/dy1-3.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "qnbg1-3-1box" }, [
                        _c("img", {
                          staticClass: "dytb1-3",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/sougou/dytb1-4.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "dytb1-4",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/sougou/dytb1-5.png")
                          },
                          on: { mousemove: _vm.showLogindy1_3 }
                        })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowdy1_4,
                          expression: "isShowdy1_4"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/dy1-4.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "dytb1-5",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/dytb1-6.png")
                        },
                        on: { click: _vm.showLogindy1_4 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowdy1_5,
                          expression: "isShowdy1_5"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/dy1-5.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "dytb1-6",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/dytb1-7.png")
                        },
                        on: { mousemove: _vm.showLogindy1_5 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowdy1_6,
                          expression: "isShowdy1_6"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/dy1-6.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "dytb1-7",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/dytb1-8.png")
                        },
                        on: { click: _vm.showLogindy1_6 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowdy1_7,
                          expression: "isShowdy1_7"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/dy1-7.png")
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "isShowdy1_7_input" },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.isShowdy1_7_input,
                              callback: function($$v) {
                                _vm.isShowdy1_7_input = $$v
                              },
                              expression: "isShowdy1_7_input"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "isShowdy1_7_textarea" },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              rows: 2,
                              resize: "none"
                            },
                            model: {
                              value: _vm.isShowdy1_7_textarea,
                              callback: function($$v) {
                                _vm.isShowdy1_7_textarea = $$v
                              },
                              expression: "isShowdy1_7_textarea"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "dytb1-8",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/dytb1-9.png")
                        },
                        on: { click: _vm.showLogindy1_7 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowdy1_8,
                          expression: "isShowdy1_8"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/dy1-9.png")
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "isShowdy1_7_input" },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.isShowdy1_7_input,
                              callback: function($$v) {
                                _vm.isShowdy1_7_input = $$v
                              },
                              expression: "isShowdy1_7_input"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "isShowdy1_7_textarea" },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              rows: 2,
                              resize: "none"
                            },
                            model: {
                              value: _vm.isShowdy1_7_textarea,
                              callback: function($$v) {
                                _vm.isShowdy1_7_textarea = $$v
                              },
                              expression: "isShowdy1_7_textarea"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "isShowdy1_7_select" },
                        [
                          _c(
                            "el-select",
                            {
                              model: {
                                value: _vm.isShowdy1_7_select,
                                callback: function($$v) {
                                  _vm.isShowdy1_7_select = $$v
                                },
                                expression: "isShowdy1_7_select"
                              }
                            },
                            _vm._l(_vm.isShowdy1_7_selectopint, function(item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "dytb1-9",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/dytb1-10.png")
                        },
                        on: { click: _vm.showLogindy1_8 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowdy1_9,
                          expression: "isShowdy1_9"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/dy1-11.png")
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowdy1_10,
                          expression: "isShowdy1_10"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/dy2-1.png")
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowdy1_11,
                          expression: "isShowdy1_11"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/dy2-2.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "dytb2-1",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/dytb2-1.png")
                        },
                        on: { mousemove: _vm.showLogindy1_10 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowdy1_12,
                          expression: "isShowdy1_12"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/dy2-3.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "dytb2-1",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/dytb2-1.png")
                        },
                        on: { click: _vm.showLogindy1_11 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowdy1_13,
                          expression: "isShowdy1_13"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/dy2-4.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "dytb2-2",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/dytb2-2.png")
                        },
                        on: { click: _vm.showLogindy1_12 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowdy1_14,
                          expression: "isShowdy1_14"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/sougou/dy2-5.png")
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
                  ]),
                  _vm._v(" "),
                  _vm.isShowdy1_1 ||
                  _vm.isShowdy1_2 ||
                  _vm.isShowdy1_3 ||
                  _vm.isShowdy1_4 ||
                  _vm.isShowdy1_5 ||
                  _vm.isShowdy1_6
                    ? _c("p", [
                        _vm._v("按照以下要求添加短语:"),
                        _c("br"),
                        _vm._v("\n\t\t\t\t\t\t\t缩写："),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("bb")]
                        ),
                        _c("br"),
                        _vm._v("\n\t\t\t\t\t\t\t内容："),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("报备：去上厕所，离开3分钟")]
                        ),
                        _c("br"),
                        _vm._v("\n\t\t\t\t\t\t\t点击"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("确定并继续添加")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowdy1_7
                    ? _c("p", [
                        _vm._v("按照以下要求添加短语："),
                        _c("br"),
                        _vm._v("缩写："),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("bb")]
                        ),
                        _c("br"),
                        _vm._v("内容："),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("报备：去上厕所，离开3分钟")]
                        ),
                        _c("br"),
                        _vm._v("点击"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("确定并继续添加")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowdy1_8 || _vm.isShowdy1_9
                    ? _c("p", [
                        _vm._v("按照以下要求添加短语："),
                        _c("br"),
                        _vm._v("缩写："),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("bb")]
                        ),
                        _c("br"),
                        _vm._v("候选位置："),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("2")]
                        ),
                        _c("br"),
                        _vm._v("内容："),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("报备：去上厕所，离开5分钟")]
                        ),
                        _c("br"),
                        _vm._v("点击"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("确定")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowdy1_10 ||
                  _vm.isShowdy1_11 ||
                  _vm.isShowdy1_12 ||
                  _vm.isShowdy1_13 ||
                  _vm.isShowdy1_14
                    ? _c("p", [
                        _vm._v("在聊天输入框中输入"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("bb")]
                        ),
                        _vm._v("，调出快捷短语，选择离开"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("5分钟")]
                        ),
                        _vm._v("的短语，并"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("发送")]
                        )
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _vm.OnInline == "false"
              ? _c(
                  "div",
                  { staticClass: "stoptip", attrs: { id: "studytip-second" } },
                  [
                    _c("div", { staticClass: "tip" }, [
                      _c("span", { staticClass: "el-icon-success" }),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v("你已完成搜狗输入法的功能学习，"),
                        _c("br"),
                        _vm._v("接下来请完成《搜狗输入法实操》。")
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "startstudy",
                          staticStyle: { width: "160px" },
                          attrs: { href: "/excelstudy" }
                        },
                        [_vm._v("去完成搜狗输入法实操")]
                      )
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n\t\t\t\t\t\t查看学习资料\n\t\t\t\t\t")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: require("../../../static/newqianniu/ppt.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("搜狗输入法练习-快捷短语.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt2
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt2(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt2 }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer2" } })
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2102e2e4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2102e2e4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/typewriting/typewriting.vue
// module id = 1673
// module chunks = 0